export default "__VITE_ASSET__BO6gViw___"